module.exports = __webpack_public_path__ + "img/icon_img13.d6604108.png";